
import { defineComponent } from "vue";

import common from "../styles/common.module.less";

const TONES: Record<string, string> = {
  top: common.badgeTop,
  recommend: common.badgeRecommend,
  personal: common.badgePersonal,
  merchant: common.badgeMerchant,
  plain: common.badgePlain,
};

export default defineComponent({
  name: "XiyouStatusBadge",
  props: {
    text: { type: String, required: true },
    tone: { type: String, default: "plain" },
  },
  setup(props) {
    return () => (
      <span class={[common.badge, TONES[props.tone] || common.badgePlain]}>
        {props.text}
      </span>
    );
  },
});
